module.exports = __webpack_public_path__ + "static/media/illus-inspiration-rect.e71fc02d.png";